import { Div, Text } from "ui";
import { formatAmount } from "utils/amounts";

import { ReactComponent as FlixxCoin } from "assets/icons/flixx-coin.svg";


const SIZES ={
  sm: 16,
  base: 20,
  xl: 24,
  '2xl': 28,
}


const Flixx = ({ price, size='base' }) => {

  const currentSize = SIZES[size]

  return (
    <Div
      as='span'
      display='inline-flex'
      align-items='center'
      height={currentSize}
      gap={6}
    >
      <Div as='span' display='grid' marginBottom={1}>
        <FlixxCoin height={currentSize} width={currentSize} />
      </Div>
      <Text as='span' size={size} color='headline'>
        {formatAmount(price)}
      </Text>
    </Div>
  )
}

export default Flixx